// resources/js/admin/services/siteService.ts

import axios from "axios";
import { Site, SiteFormData } from "../types/features/Site";
import { MAIN_API_URL } from "../config/api";
import { PaginatedResponse } from "../types/core/PaginatedResponse";

export const siteService = {
  // 🔓 PUBLIC - Pas de token nécessaire (lecture) - AVEC PAGINATION
  async getAll(
    page: number = 1,
    perPage: number = 20,
    search?: string,
    isActive?: boolean
  ): Promise<PaginatedResponse<Site>> {
    try {
      const response = await axios.get(`${MAIN_API_URL}/sites`, {
        params: { page, per_page: perPage, search, is_active: isActive },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors du chargement des sites", error);
      throw error;
    }
  },

  // 🔓 PUBLIC - Pas de token nécessaire (lecture)
  async getById(id: string): Promise<Site> {
    try {
      const response = await axios.get(`${MAIN_API_URL}/sites/${id}`);
      return response.data;
    } catch (error) {
      console.error("Erreur lors du chargement du site", error);
      throw error;
    }
  },

  // 🔓 PUBLIC - Pas de token nécessaire (lecture)
  async getBySlug(slug: string): Promise<Site> {
    try {
      const response = await axios.get(`${MAIN_API_URL}/sites/slug/${slug}`);
      return response.data;
    } catch (error) {
      console.error("Erreur lors du chargement du site par slug", error);
      throw error;
    }
  },

  // 🔒 PROTÉGÉ - Token requis
  async create(token: string, data: SiteFormData): Promise<Site> {
    try {
      const response = await axios.post(`${MAIN_API_URL}/sites`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la création du site", error);
      throw error;
    }
  },

  // 🔒 PROTÉGÉ - Token requis
  async update(token: string, id: string, data: Partial<SiteFormData>): Promise<Site> {
    try {
      const response = await axios.put(`${MAIN_API_URL}/sites/${id}`, data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      return response.data;
    } catch (error) {
      console.error("Erreur lors de la mise à jour du site", error);
      throw error;
    }
  },

  // 🔒 PROTÉGÉ - Token requis
  async delete(token: string, id: string): Promise<void> {
    try {
      await axios.delete(`${MAIN_API_URL}/sites/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      console.error("Erreur lors de la suppression du site", error);
      throw error;
    }
  },

  // 🔒 PROTÉGÉ - Token requis
  async deleteMany(token: string, ids: string[]): Promise<void> {
    try {
      await axios.post(`${MAIN_API_URL}/sites/delete-many`, { ids }, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      console.error("Erreur lors de la suppression multiple", error);
      throw error;
    }
  },
};